import React from 'react'

const BymaHome = () => (<div></div>)

export default BymaHome